import { getRequestMeta, type Case } from '../../types';

/** "Oct 20, 2026" for the date part of an ISO date or timestamp, read as a calendar day (no time-zone shift). */
export function formatDay(value: string | null | undefined): string | null {
  const match = value?.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;
  const day = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
  if (Number.isNaN(day.getTime())) return null;
  return day.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}

/**
 * The line over the request text in the Purview search builder (R2-12):
 * "24-137 · Harbor & Vale LLP · opened Oct 20, 2026 · due Nov 18, 2026". The
 * server gives the LLM the same two dates.
 */
export function purviewRequestMeta(caseData: Pick<Case, 'metadata' | 'created_at'>): string | null {
  const meta = getRequestMeta(caseData);
  const plain = (caseData.metadata ?? {}) as Record<string, unknown>;
  const requester = meta?.requester ?? (typeof plain.requester === 'string' ? plain.requester : null);
  const opened = formatDay(caseData.created_at);
  const due = formatDay(meta?.due_date);
  const parts = [
    meta?.request_number,
    requester,
    opened && `opened ${opened}`,
    due && `due ${due}`,
  ].filter(Boolean);
  return parts.length ? parts.join(' · ') : null;
}
